import { useEffect } from "react";

/**
 * Inject one or more JSON-LD <script> blocks into <head> for the current route
 * and remove them on unmount / when the data changes. Each entry is { id, data }
 * where `id` keeps the tag unique (so we update instead of duplicating) and
 * `data` is a plain JS object serialized to application/ld+json.
 *
 * Used for per-page structured data (BreadcrumbList, FAQPage, Beach, ...) so
 * individual routes can rank on their own in Google.
 */
export function useJsonLd(scripts) {
  const serialized = JSON.stringify(scripts || []);
  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    const list = JSON.parse(serialized);
    if (!list.length) return undefined;
    const els = list.map(({ id, data }) => {
      let el = document.getElementById(id);
      if (!el) {
        el = document.createElement("script");
        el.type = "application/ld+json";
        el.id = id;
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(data);
      return el;
    });
    return () => {
      els.forEach((el) => {
        if (el && el.parentNode) el.parentNode.removeChild(el);
      });
    };
  }, [serialized]);
}

export default useJsonLd;
